import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { DataService_BlockListSetup } from "../shared/data.service";
import { ConfirmationService } from "primeng/api";
import { StationBlockAlertAssignmentToggleRequest } from "../shared/station-block-alert-assignment-toggle-request";
import { StationBlockAlertAssignRequest } from "../shared/station-block-alert-assign-request";
import { SBAssignmentAddGroupComponent } from "./sbassignment-add-group/sbassignment-add-group.component";
import { DialogService } from "primeng/dynamicdialog";
import { SBAssignmentAddHomeroomComponent } from "./sbassignment-add-homeroom/sbassignment-add-homeroom.component";
import { SBAssignmentAddStudentComponent } from "./sbassignment-add-student/sbassignment-add-student.component";

@Component({
	selector: "caass-station-block-alert-assignment-table",
	templateUrl: "./station-block-alert-assignment-table.component.html",
	styleUrls: ["./station-block-alert-assignment-table.component.css"],
})
export class StationBlockAlertAssignmentTableComponent implements OnInit, OnChanges {
	constructor(private dataService: DataService_BlockListSetup, private confirmationService: ConfirmationService, private dialogService: DialogService) {}
	ngOnInit(): void {
		this.loadTable();
	}
	ngOnChanges(changes: SimpleChanges): void {
		this.loadTable();
	}

	///////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////

	@Input() SelectedStationBlockAlert: any;

	SelectedItems: any = [];
	lstTable: any = [];
	lstTypeDesc: any = [];
	lstActiveDesc: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	ToggleText: string = "Deactivate";

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////

	loadTable() {
		this.errorMessage = "";

		this.lstTable = [];
		this.SelectedItems = [];

		if (this.SelectedStationBlockAlert == undefined || this.SelectedStationBlockAlert.StationBlockAlertID == undefined) {
			return;
		}

		this.TableLoading = true;

		var result = this.dataService.StationBlockAlertAssignmentsSelectList(this.SelectedStationBlockAlert.StationBlockAlertID);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				this.lstTypeDesc = Array.from(new Set(this.lstTable.map((item: any) => item.TypeDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstTable.map((item: any) => item.ActiveDesc))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadTable();
	}

	onAddGroup() {
		this.errorMessage = "";

		var ref = this.dialogService.open(SBAssignmentAddGroupComponent, {
			header: "Add Groups",
			width: "fit-content",
			data: {
				SelectedStationBlockAlert: this.SelectedStationBlockAlert,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onAddHomeroom() {
		this.errorMessage = "";

		var ref = this.dialogService.open(SBAssignmentAddHomeroomComponent, {
			header: "Add Homerooms",
			width: "fit-content",
			data: {
				SelectedStationBlockAlert: this.SelectedStationBlockAlert,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onAddStudent() {
		this.errorMessage = "";

		var ref = this.dialogService.open(SBAssignmentAddStudentComponent, {
			header: "Add Students",
			width: "fit-content",
			data: {
				SelectedStationBlockAlert: this.SelectedStationBlockAlert,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onActivate() {
		this.onToggle(1);
	}

	onDeactivate() {
		this.onToggle(0);
	}

	onToggle(ChangeTo: number) {
		this.errorMessage = "";

		if (this.SelectedItems == undefined || this.SelectedItems.length == 0) {
			this.errorMessage = "Select items to deactivate";
			return;
		}

		this.Processing = true;

		var lstType = this.SelectedItems.map((item: any) => item.TypeID);
		var lstItem = this.SelectedItems.map((item: any) => item.ItemID);

		var parms: StationBlockAlertAssignmentToggleRequest = {
			StationBlockAlertID: this.SelectedStationBlockAlert.StationBlockAlertID,
			lstTypeID: lstType,
			lstItemID: lstItem,
			Active: ChangeTo,
		};

		var result = this.dataService.StationBlockAlertAssignmentToggle(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalertassignment",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Items were " + (ChangeTo == 1 ? "Activated" : "Deactivated") + " Successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalertassignment",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (ChangeTo == 1 ? "Activate" : "Deactivate") + " Items: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedItems == undefined || this.SelectedItems.length == 0) {
			this.errorMessage = "Select items to delete";
			return;
		}

		var lstPID: number[] = [];
		var lstGID: number[] = [];
		var lstHID: number[] = [];

		for (var z = 0; z < this.SelectedItems.length; z++) {
			var next = this.SelectedItems[z];

			if (next.TypeID == 1) {
				lstPID = [...lstPID, Number(next.ItemID)];
			}
			if (next.TypeID == 2) {
				lstGID = [...lstGID, Number(next.ItemID)];
			}
			if (next.TypeID == 3) {
				lstHID = [...lstHID, Number(next.ItemID)];
			}
		}

		var Msg: string = "You are about to unblock ";
		Msg += lstPID.length + " Student" + (lstPID.length == 1 ? "" : "s") + ", ";
		Msg += lstGID.length + " Group" + (lstGID.length == 1 ? "" : "s") + ", and ";
		Msg += lstHID.length + " Homeroom" + (lstHID.length == 1 ? "" : "s") + ". ";
		Msg += "Are you sure you want to continue?";

		this.confirmationService.confirm({
			key: "stationblockalertassignmentconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete(lstPID, lstGID, lstHID);
			},
		});
	}

	onFinishDelete(lstPID: number[], lstGID: number[], lstHID: number[]) {
		this.Processing = true;

		var parms: StationBlockAlertAssignRequest = {
			StationBlockAlertID: this.SelectedStationBlockAlert.StationBlockAlertID,
			lstPersonID: lstPID,
			lstGroupID: lstGID,
			lstHomeroomID: lstHID,
		};

		var result = this.dataService.StationBlockAlertUnassign(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalertassignment",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Items were Deleted Successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalertassignment",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete Items: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////////
}
